<template>
  <Sidebar>
    <div class="border-bottom border-white border-2">
      <div class="p-4 mx-3">
        <span
          class="cursor-pointer"
          style="font-size: 8px;"

          @click="$router.push('/')"
        >
          MY PROJECTS
        </span>
        <h6>
          <b class="text-uppercase">{{ researchName }}</b>
        </h6>
      </div>
    </div>
    <ul class="py-2 nav">
      <li
        v-for="route in routes"
        :key="route.name"
        class="d-block px-4 py-2 w-100"
        :class="{'active': '/' + $route.path.split('/').pop() == route.to}"
        :style="isResearchNew ? 'pointer-events: none': ''"
      >
        <router-link
          :to="rootPath + route.to"
          class="mx-3"
          :class="
            `/${$route.path.split('/').pop()}` == route.to ?
              'deepify-light-text' :
              'deepify-dark-text'
          "
        >
          {{ route.name }}
        </router-link>
      </li>
    </ul>
  </Sidebar>
</template>

<script>
import Sidebar from '@/components/core/Sidebar';

export default {
  components: {
    Sidebar,
  },
  props: {
    researchName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      routes: [
        {
          name: 'BRIEF',
          to: '/brief',
        },
        {
          name: 'CLUSTERS',
          to: '/clusters',
        },
        {
          name: 'RESEARCH',
          to: '/research',
        },
      ],
    };
  },
  computed: {
    isResearchNew() {
      return !this.$route.params.id;
    },
    rootPath() {
      if (this.isResearchNew) return '/research';

      return `/research/${this.$route.params.id}`;
    },
  },
};
</script>

<style scoped>
    .active {
        background: #686868;
    }
</style>
